import PropTypes from 'prop-types';
import React from 'react';

const Politics = ({ color }) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="24px"
    height="24px"
    viewBox="0 0 24 24"
  >
    <g strokeWidth="1" fill="none" fillRule="evenodd">
      <g transform="translate(-128.000000, -2555.000000)" fill="#999999">
        <g transform="translate(128.000000, 2555.000000)">
          <path
            fill={color}
            d="M20.9839194,20.62327 L20.6230408,20.9841485 C20.4954653,21.1114186 20.2798854,21.1114186 20.1524626,20.9841485 L12.8963905,13.7280764 L13.7278472,12.8966196 L20.9839194,20.1523862 C21.111495,20.2801146 21.111495,20.4955416 20.9839194,20.62327 L20.9839194,20.62327 Z M9.50272679,14.2981178 L6.20333156,10.9985698 L10.9984934,6.20340796 L14.2980414,9.50295597 L9.50272679,14.2981178 Z M7.99932095,17.5855958 L2.91585358,12.514504 L3.89948435,11.5184976 L8.97684032,16.5958536 L7.99932095,17.5855958 Z M12.502052,2.91592997 L17.5801719,7.99236923 L16.6017358,8.9831809 L11.5245326,3.90582493 L12.502052,2.91592997 Z M22.3956541,18.7406515 L15.1397347,11.4847321 L15.8106143,10.8138525 C16.0607236,10.9211077 16.327792,10.9762631 16.5956244,10.9762631 C17.1045517,10.9762631 17.6137846,10.7823788 18.0012477,10.3947629 L18.9972541,9.3987565 L18.9972541,9.3987565 C19.3718833,9.02412732 19.578296,8.52497825 19.578296,7.99313316 C19.578296,7.46144085 19.3718833,6.96229178 18.9972541,6.5876626 L13.9137867,1.50419523 C13.1387077,0.729421751 11.8776191,0.729268966 11.1025401,1.50434801 L10.1066865,2.50020159 C9.73190451,2.87483077 9.52549178,3.37397984 9.52549178,3.90582493 C9.52549178,4.1808382 9.58171671,4.44668435 9.68683289,4.69144615 L4.69060584,9.68767321 C3.96518196,9.37690822 3.09140371,9.51548435 2.5001252,10.1067629 L1.50411883,11.1026164 C1.12948966,11.4772456 0.923076923,11.9763947 0.923076923,12.5083926 C0.923076923,13.0402377 1.12948966,13.5393867 1.50411883,13.9138631 L6.58758621,18.9974833 C6.97504934,19.3847936 7.48397666,19.578678 7.99305676,19.578678 C8.50213687,19.578678 9.01121698,19.3847936 9.39883289,18.9973305 L10.3946865,18.0013241 C10.7694684,17.626695 10.9757284,17.1275459 10.9757284,16.5957008 C10.9757284,16.3206875 10.9196562,16.0548414 10.8145401,15.8100796 L11.4846557,15.1398111 L18.7405751,22.3958833 C19.1795268,22.834835 19.7645411,23.0763883 20.3877517,23.0763883 C21.0109623,23.0763883 21.5958239,22.834835 22.0347756,22.3958833 L22.3956541,22.0350048 C23.3039618,21.1268499 23.3039618,19.6489592 22.3956541,18.7406515 L22.3956541,18.7406515 Z"
          />
        </g>
      </g>
    </g>
  </svg>
);

Politics.propTypes = {
  color: PropTypes.string,
};

Politics.defaultProps = {
  color: '#999999',
};

export default Politics;



// WEBPACK FOOTER //
// ./src/components/Icon/Politics.js